const generateWatermark = (text, options = {}) => {
    const { 
      fontSize = 16, 
      color = 'rgba(128,128,128,0.06)', 
      angle = 45,
      open = true
    } = options;
  
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    // 根据文字长度调整Canvas尺寸
    ctx.font = `${fontSize}px Arial`;
    const dpr = window.devicePixelRatio || 1;
    const textWidth = ctx.measureText(text).width;
    const size = Math.max(100, textWidth * 1.5); // 基础平铺尺寸
    canvas.width = size * dpr;
    canvas.height = size * dpr;
  
    // 绘制旋转文字
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((Math.PI / 180) * angle);
    ctx.scale(dpr, dpr);
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, 0, 0);
  
    return canvas.toDataURL('image/png');
  };
  
  // 防抖函数，确保在多次快速调整窗口大小时不会频繁触发
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  export const watermarkDirective = {
    mounted(el, binding) {
      const { text, visible = true, ...options } = binding.value;
      
      // 创建水印容器（延迟创建直到首次需要显示）
      let watermarkDiv = null;
      const createWatermark = () => {
        if (!watermarkDiv && visible) {
          const watermarkUrl = generateWatermark(text, options);
          watermarkDiv = document.createElement('div');
          watermarkDiv.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
            pointer-events: none;
            background-image: url('${watermarkUrl}');
            background-repeat: repeat;
            display: ${visible ? 'block' : 'none'};
          `;
          el.style.position = el.style.position || 'relative';
          el.appendChild(watermarkDiv);
          el._watermarkElement = watermarkDiv;
        }
      };
   
      // 初始化显示状态
      createWatermark();
   
      // 添加可见性监听
      const toggleVisibility = (newVal) => {
        if (watermarkDiv) {
          watermarkDiv.style.display = newVal ? 'block' : 'none';
        } else if (newVal) {
          createWatermark();
        }
      };
   
      // 设置观察器（使用Vue的watch模式）
      el._watermarkWatcher = (newVal, oldVal) => {
        if (newVal.visible !== oldVal.visible) {
          toggleVisibility(newVal.visible);
        }
        
        // 同时处理配置更新
        if (newVal.text !== oldVal.text || 
            Object.keys(newVal).some(k => k !== 'visible' && newVal[k] !== oldVal[k])) {
          if (watermarkDiv && newVal.visible) {
            watermarkDiv.style.backgroundImage = `url('${generateWatermark(newVal.text, newVal)}')`;
          }
        }
      };
   
      // 初始化观察
      el._watermarkWatcher(binding.value, { visible: false });
   
      // 窗口调整处理
      el._resizeHandler = debounce(() => {
        if (watermarkDiv && visible) {
          // 可选：在resize时重新生成水印（根据需求决定）
          // watermarkDiv.style.backgroundImage = `url('${generateWatermark(text, options)}')`;
        }
      }, 200);
      window.addEventListener('resize', el._resizeHandler);
    },
   
    updated(el, binding) {
      // 使用观察器代替直接更新
      if (el._watermarkWatcher) {
        el._watermarkWatcher(binding.value, el._lastBinding || {});
        el._lastBinding = binding.value;
      }
    },
   
    unmounted(el) {
      window.removeEventListener('resize', el._resizeHandler);
      if (el._watermarkElement) {
        el.removeChild(el._watermarkElement);
      }
      // 清理观察器
      el._watermarkWatcher = null;
      el._lastBinding = null;
    }
  };